import { render, staticRenderFns } from "./SyntageInfo.vue?vue&type=template&id=1a7b3dfe&"
import script from "./SyntageInfo.vue?vue&type=script&lang=js&"
export * from "./SyntageInfo.vue?vue&type=script&lang=js&"
import style0 from "./SyntageInfo.vue?vue&type=style&index=0&id=1a7b3dfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports